import { Avatar } from "../components/Avatar";
import { ConversationMessageContent } from "../components/ConversationMessages";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from "../components/Dropdown";
import { IconButton } from "../components/IconButton";
import { MoreIcon } from "../icons/app";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
export const ConversationContainer = React.forwardRef(({ children, className, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn("s-flex s-h-full s-w-full s-flex-col s-items-center s-@container/conversation", className), ...props },
        React.createElement("div", { className: "s-flex s-w-full s-max-w-4xl s-flex-col s-gap-6 s-p-2 @sm/conversation:s-gap-8 @md/conversation:s-gap-10" }, children)));
});
ConversationContainer.displayName = "ConversationContainer";
const messageVariants = cva("s-flex s-w-full s-flex-col s-rounded-2xl", {
    variants: {
        type: {
            user: "s-bg-muted-background dark:s-bg-muted-background-night s-px-5 s-py-4 s-gap-2",
            agent: "s-w-full s-gap-3",
        },
    },
    defaultVariants: {
        type: "agent",
    },
});
const buttonsVariants = cva("s-flex s-justify-start s-gap-2 s-pt-2", {
    variants: {
        type: {
            user: "s-justify-end",
            agent: "s-justify-start",
        },
    },
    defaultVariants: {
        type: "agent",
    },
});
/**
 * Parent component for both UserMessage and AgentMessage, to ensure avatar,
 * side buttons and spacing are consistent between the two
 */
export const ConversationMessage = React.forwardRef(({ avatarBusy = false, buttons, children, citations, isDisabled = false, name, timestamp, completionStatus, pictureUrl, renderName = (name) => React.createElement("span", null, name), infoChip, type, actions, className, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: "s-group/message" },
        React.createElement("div", { className: cn(messageVariants({ type, className })), ...props },
            React.createElement(ConversationMessageHeader, { avatarUrl: pictureUrl, name: name, timestamp: timestamp, completionStatus: completionStatus, isBusy: avatarBusy, isDisabled: isDisabled, renderName: renderName, infoChip: infoChip, actions: actions }),
            React.createElement(ConversationMessageContent, { citations: citations, type: type }, children)),
        buttons && (React.createElement("div", { className: cn(buttonsVariants({ type, className })) }, buttons))));
});
ConversationMessage.displayName = "ConversationMessage";
const ConversationMessageHeader = React.forwardRef(({ avatarUrl, isBusy, isDisabled, name = "", timestamp, infoChip, completionStatus, renderName, actions, className, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn("s-flex s-items-center s-gap-2 s-p-1 @sm/conversation:s-p-0", className), ...props },
        React.createElement(Avatar, { className: "@sm:s-hidden", name: name, visual: avatarUrl, busy: isBusy, disabled: isDisabled, size: "xs" }),
        React.createElement(Avatar, { className: "s-hidden @sm:s-flex", name: name, visual: avatarUrl, busy: isBusy, disabled: isDisabled, size: "sm" }),
        React.createElement("div", { className: "s-inline-flex s-w-full s-justify-between s-gap-0.5" },
            React.createElement("div", { className: "s-inline-flex s-items-baseline s-gap-2 s-text-foreground dark:s-text-foreground-night" },
                React.createElement("span", { className: "s-heading-sm" }, renderName(name)),
                React.createElement("span", { className: "s-heading-xs s-text-muted-foreground dark:s-text-muted-foreground-night" }, timestamp),
                infoChip && infoChip),
            React.createElement("div", { className: "s-flex s-items-center s-gap-2" }, completionStatus !== null && completionStatus !== void 0 ? completionStatus : null,
                actions && actions.length > 0 && (React.createElement(DropdownMenu, null,
                    React.createElement(DropdownMenuTrigger, { asChild: true },
                        React.createElement(IconButton, { icon: MoreIcon, size: "xs", variant: "highlight-secondary", "aria-label": "Message actions" })),
                    React.createElement(DropdownMenuContent, null, actions.map((action, index) => (React.createElement(DropdownMenuItem, { key: index, icon: action.icon, label: action.label, onClick: action.onClick }))))))))));
});
ConversationMessageHeader.displayName = "ConversationMessageHeader";
//# sourceMappingURL=ConversationMessage.js.map